import React from 'react'
import Spinner from '../Common/Spinner/index'
import { Input } from 'reactstrap'
import "./authenticator.css"

const AdminAuthenticator = ({ MFAsourceCode, handleChange, errorValidateMessage, otp, isQrVisible, handleSubmitOtp, isLoading, email, ...props }) => {
    return (
        <div {...props} className="container-fluid authenticator-container">
            <div className="row col-md-12 col-12 col-lg-3 col-xl-3">
                <div className="col-xs-6 left">

                    {isQrVisible ?
                        <>
                            <h1 className="authenticator mb-3">Authenticator Code</h1>
                            <img alt="qrcode" className="js-qrcode qrcode" src={MFAsourceCode} />
                            <div className="scan">
                                Scan with <a href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en_IN&gl=US" rel='noopener noreferrer' target="_blank">Google Authenticator App</a>
                            </div>
                        </>
                        :
                        null
                    }

                    <div className="col-lg-12 d-flex flex-column authText">
                        <span>Please refer to your Google Authenticator and copy code from  Nomadic Care  <span className='authEmail'> <a target="_blank">{email}</a></span></span>
                        {/* <span> Nomadic Care  <span className='authEmail'> <a target="_blank">{email}</a></span></span> */}

                    </div>
                    {/* <img alt="qrcode" className="js-qrcode qrcode" src="https://chart.googleapis.com/chart?chs=166x166&amp;chld=L|0&amp;cht=qr&amp;chl=otpauth%3A%2F%2Ftotp%2FACME%2520Co%3Ajohn%40example.com%3Fsecret%3DHXDMVJECJJWSRB3HWIZR4IFUGFTMXBOZ%26issuer%3DACME%2520Co%26algorithm%3DSHA1%26digits%3D6%26period%3D30" /> */}

                    <div className="verify">
                        <div className="col-lg-12">

                            <Input
                                title="Email Address*"
                                type="number"
                                className="form-control custom-input"
                                placeholder="Enter Code*"
                                name="otp"
                                value={otp}
                                onChange={handleChange}
                            />
                            <span className="error-message-text error-text">{errorValidateMessage?.["otp"]}              </span>
                        </div>
                        <div className="col-lg-12">
                            <button disabled={isLoading} className="log-btn mt-3 d-flex justify-content-center align-items-center" onClick={handleSubmitOtp}>
                                Submit Code
                                {isLoading ? <Spinner size='sm' className="ml-2" variant='light' animation='border' /> : null}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AdminAuthenticator